import { ReactNode } from 'react'

interface ProxyMarketActionsCellProps {
  children: ReactNode
}

export function ProxyMarketActionsCell({ children }: ProxyMarketActionsCellProps) {
  return (
    <div
      className="mt-4 flex justify-end md:mt-0"
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <div className="grid w-full grid-cols-2 grid-rows-2 gap-2 md:w-[164px]">{children}</div>
    </div>
  )
}
